import { render, staticRenderFns } from "./product-title.vue?vue&type=template&id=8b054bd2&scoped=true"
import script from "./product-title.vue?vue&type=script&lang=js"
export * from "./product-title.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b054bd2",
  null
  
)

export default component.exports